import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

interface FeedbackModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FeedbackModal({ open, onOpenChange }: FeedbackModalProps) {
  // Contact details — update names if needed
  const contacts = [
    { name: 'Matthew Bazire' },
    { name: 'Cheech Sia' },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Feedback / Help</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground mb-4">
          Need help or have feedback about the Financial Governance app? Get in touch with the team:
        </p>
        <div className="space-y-4">
          {contacts.map((contact) => (
            <div key={contact.name} className="flex items-center border rounded-lg p-4">
              <span className="font-medium">{contact.name}</span>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
